<template>
  <div class="form-view">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form-content" :label-width="formLabelWidth">
      <p class="form-sub-title">基本信息</p>
      <el-row class="form-row" :gutter="20">
        <el-col :span="12">
          <el-form-item label="公司名称" prop="memberName">
            <el-input v-model="ruleForm.memberName" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="industry">
            <el-select placeholder="行业" clearable v-model="ruleForm.industry" class="input-with-select">
              <el-option v-for="item in industrys" :label="item.name" :value="item.name" :key="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="省" prop="province">
            <el-select placeholder="省" clearable v-model="ruleForm.province" @change="provinceChange" class="input-with-select">
              <el-option v-for="(item, index) in provinces" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="市" prop="city">
            <el-select placeholder="市" clearable v-model="ruleForm.city" class="input-with-select">
              <el-option v-for="(item, index) in curProvince.city" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成立时间" prop="establishmentTime">
            <el-date-picker type="date" class="input-with-select" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="ruleForm.establishmentTime "></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规模" prop="personnelSize">
            <el-input v-model="ruleForm.personnelSize" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人" prop="legalPerson">
            <el-input v-model="ruleForm.legalPerson" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="contactNumber">
            <el-input v-model="ruleForm.contactNumber" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册资金" prop="registeredCapital">
            <el-input v-model="ruleForm.registeredCapital" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="注册地址" prop="registrationAddress">
            <el-input v-model="ruleForm.registrationAddress" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="经营范围" prop="businessScope">
            <el-input v-model="ruleForm.businessScope" type="textarea" placeholder="经营范围" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
         
      </el-row>
    </el-form>
    <div class="footer">
      <el-button type="primary" class="submit" @click="submit('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
import formRules from '@/utils/rules'
import companyApi from '@/api/company'
import authApi from '@/api/auth'
export default {
  name: 'AddCompany',
  props: ['rowId'],
  data () {
    return {
      rules: {
        memberName: [formRules.inputRequired],
        industry: [formRules.selectRequired],
        city: [formRules.selectRequired],
        contactNumber: [formRules.contact]
      },
      formLabelWidth: '100px',
      ruleForm: {
        city: ''
      },
      industrys: [],
      provinces: [],
      curProvince: []
    }
  },
  methods: {
    provinceChange () {
      this.curProvince = this.provinces.find(p => p.name === this.ruleForm.province)
      this.ruleForm.city = ''
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.rowId) {
            companyApi.updateForMajor(this.ruleForm).then(res => {
              this.$message.success('修改成功!')
              this.$emit('action')
            })
          } else {
            companyApi.insertForMajor(this.ruleForm).then(res => {
              this.$message.success('新增成功!')
              this.$emit('action')
            })
          }
        }
      })
    },
    getIndustry (typeCode) {
      authApi.dicInfo({
        typeCode
      }).then(res => {
        this.industrys = res
      })
    },
    getProvince () {
      return authApi.selectProvince()
    }
  },
  async mounted () {
    this.getIndustry('TYPE_TWO')
    this.provinces = await this.getProvince()
    this.provinces.forEach(p => {
      if (p.city.length === 0) {
        p.city.push(p)
      } 
    })
    if (this.rowId) {
      companyApi.queryDetailForMajorByRowId({
        rowId: this.rowId
      }).then(res => {
        this.provinces.forEach(p => {
          if (p.city.some(c => c.name === res.city)) {
            res.province = p.name
          }
        })
        this.ruleForm = res
      })
    } 
  }
}
</script>

<style scoped lang="less">
.simpleWarp {
  float: left;
  width: 100%;
  border: 1px solid #d9ecff;
  background: #fbfdff;
  margin: 10px 0;
  .cons {
    color: #1e88e5;
    padding: 10px 0 14px 22px;
    span {
      float: right;
      border: 1px solid #63b1ff;
      background: #d5eaff;
      padding: 5px;
      cursor: pointer;
      margin: 0 20px 0 0;
      &:hover {
        background: rgba(213, 234, 255, 0.5);
      }
    }
  }
  .consList {
    width: 100%;
    overflow: hidden;
    .consIndex {
      float: right;
      border: 1px solid #ff5b36;
      background: rgba(255, 91, 54, 0.3);
      padding: 5px;
      cursor: pointer;
      margin: 10px 10px 0 0;
      &:hover {
        background: rgba(255, 91, 54, 0.5);
      }
    }
  }
}
</style>
